import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";

// import leaf from "../../Assets/Projects/leaf.png";
// import emotion from "../../Assets/Projects/emotion.jpeg";
// import editor from "../../Assets/Projects/codeEditor.png";
import bodyshop from "../../Assets/Projects/bodyshop.png";
import lynda from "../../Assets/Projects/lynda.png";
// import bitsOfCode from "../../Assets/Projects/blog.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bodyshop}
              isBlog={false}
              title="Bodyshop"
              description={<p>Online E commerce cloned with the help of <span className="techstacks">Html,Css,Javascript</span> with added Cart functionality where data is being passed onto different page using local storage ,created OTP based login and logout functionality ,once the product is ordered successfully it redirects to about us pagethen to homepage itself</p>}
              link="https://mramit-itech.github.io/AmitsProjects/bodyshop"
              codelink='https://github.com/MrAmit-itech/AmitsProjects/tree/main/bodyshop'
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={lynda}
              isBlog={false}
              title="Lynda"
              description= {<p>Online education based platform where user can expolore and purchase the course according to there meet.<span className='techstacks'>Html,Css,Javascript</span> in frontened and node,mongodb are used in backened where the data are being fetched using API from mongo db and is displayed to front end using DOM techniques</p>}
              link="https://mramit-itech.github.io/AmitsProjects/lynda"
              codelink='https://github.com/MrAmit-itech/AmitsProjects/tree/main/lynda'
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={lynda}
              isBlog={false}
              title="Lynda"
              description={<p>Online education based platform where user can expolore and purchase the course according to there meet.<span className="techstacks">Html,Css,Javascript</span> in frontened and <span className="techstacks">Node,Mongodb</span> are used in backened where the data are being fetched using API from mongo db and is displayed to front end using DOM techniques</p>}
              link="https://mramit-itech.github.io/AmitsProjects/lynda"
              codelink='https://github.com/MrAmit-itech/AmitsProjects/tree/main/lynda'
            />
          </Col>
         

          {/* <Col md={4} className="project-card">
            <ProjectCard
              imgPath={suicide}
              isBlog={false}
              title="Ai For Social Good"
              description="Using 'Natural Launguage Processing' for the detection of suicide-related posts and user's suicide ideation in cyberspace  and thus helping in sucide prevention."
              link="https://github.com/soumyajit4419/AI_For_Social_Good"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={emotion}
              isBlog={false}
              title="Face Recognition and Emotion Detection"
              description="Trained a CNN classifier using 'FER-2013 dataset' with Keras and tensorflow backened. The classifier sucessfully predicted the various types of emotions of human. And the highest accuracy obtained with the model was 60.1%.
              Then used Open-CV to detect the face in an image and then pass the face to the classifer to predict the emotion of a person."
              link="https://github.com/soumyajit4419/Face_And_Emotion_Detection"
            />
          </Col> */} 
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
